module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordListElement/images/button_heart_highlight.94864dc96503a6150e54f8121d9e1556.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordListElement/images/button_heart_highlight.svg
// module id = 1679
// module chunks = 1